import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { RbacService } from "./rbac.service";

@Injectable()
export class RbacInterceptor implements HttpInterceptor {
    constructor(private rbacService: RbacService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.rbacService.canRequest(request.method, request.urlWithParams)) {
            return next.handle(request);
        }

        return throwError(() => new HttpErrorResponse({
            status: 403,
            statusText: "Forbidden",
            url: request.urlWithParams,
            error: { message: "Operazione non consentita per il ruolo corrente" }
        }));
    }
}
